import React from 'react';
import { Layout, Typography, Row, Col, Button, Space } from 'antd';
import headerImage from '@assets/Images/header_image.jpeg';
import './main.css';
import { Link } from 'react-router-dom';

const { Content } = Layout;
const { Title } = Typography;

function Main() {
  return (
    <Content>
      <div className="image-container">

        <img src={headerImage} alt="Teaming" />
        <div className="gradient-overlay"></div>
        <h1 className="page-title">Gila Dynamics</h1>
        <h2 className="page-subtitle">
          Creating Simple Apps for iOS and Android
        </h2>
      </div>
      <Space direction="vertical" size={["small", "large"]} style={{ padding: '20px', display: 'flex' }}>
        <Row>
          <Col span={24}>
            <div className="company-intro">
              <h1>We create simple apps for iOS and Android<br />that make your daily life easier and more fun</h1>
              <p>
                At Gila Dynamics, we are passionate about developing our own apps for consumers. Our simple apps are designed to help people in their daily lives, whether it's through productivity tools, entertaining games, or convenient utilities. We focus on quality, user-friendly designs, and innovative ideas to bring joy and convenience to users on iOS and Android platforms. Trust us to deliver apps that enhance your everyday experience.
              </p>
              <Link to="/about">
                <Button type="primary" size="large">
                  Learn More
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className="why-choose">
              <Title level={2}>Why Choose Gila Dynamics Apps?</Title>
              <ul>
                <li>
                  Simple, user-friendly apps tailored for everyday use on iOS and Android
                </li>
                <li>Experienced developers passionate about creating fun and useful consumer apps</li>
                <li>Reliable, efficient, and high-quality apps that enhance daily life</li>
                <li>
                  Constantly innovating to bring new ideas and features to our apps
                </li>
              </ul>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className="quote-container">
              <p className="quote-text">
                "Passionate about creating apps that bring joy and convenience to everyday life"
              </p>
              <p className="quote-source">- Gila Dynamics</p>
            </div>
          </Col>
        </Row>
        {/* <Row>
          <Col span={24}>
            <Card>
              <Title level={3}>Ready to Get Started?</Title>
              <Text>
                Contact us today to learn more about how Gila Dynamics can help your organization take advantage of the latest technologies and improve its performance with custom software solutions.
              </Text>
              <br />
              <Button type="primary" size="large" style={{ marginTop: '20px' }}>
                Get in Touch
              </Button>
            </Card>
          </Col>
        </Row> */}
      </Space>
    </Content>
  );
}

export default Main;
